import React from 'react';
import { t, Trans } from '@lingui/macro';
import { useCurrentAgreement, useCurrentUser } from '@economic/react-app';
import { Field, Input, Spinner, Tooltip } from '@economic/taco';
import useQuery from '~/app/shared/hooks/useQuery';
import ContactInformationGraphic from './images/woman-teaches-man-on-laptop.svg';

interface Props {
    children: string | JSX.Element;
}

export default function ContactForm({ children }: Props) {
    const user = useCurrentUser();
    const agreement = useCurrentAgreement();
    const { data: companyData, loading: companyDataLoading } = useQuery<any>('/company/getCurrentCompany', null, {});

    if (companyDataLoading) {
        return <Spinner />;
    }

    return (
        <>
            <div className="mb-2">{children}</div>
            <div className="flex flex-row">
                <div className="mt-6 basis-3/5">
                    <h2 className="mb-6">
                        <Trans>Your contact information</Trans>
                    </h2>
                    <p className="mb-4">
                        <Trans>
                            The following information will be shared with Rackbeat in order to contact you. This can always be
                            changed later.
                        </Trans>
                    </p>
                    <Tooltip title={t`Information can be changed under master information in settings`} placement="right">
                        <div>
                            <Field>
                                {t`Company name`}
                                <Input aria-label={t`Company name`} value={companyData?.model.name} readOnly />
                            </Field>
                            <Field>
                                {t`e-conomic agreement number`}
                                <Input aria-label={t`e-conomic agreement number`} value={agreement.number} readOnly />
                            </Field>
                            <Field>
                                {t`Full name`}
                                <Input aria-label={t`Full name`} value={`${user.firstName} ${user.lastName}`} readOnly />
                            </Field>
                            <Field>
                                {t`Phone`}
                                <Input aria-label={t`Phone`} value={companyData?.model.phone} readOnly />
                            </Field>
                            <Field>
                                {t`Email Address`}
                                <Input aria-label={t`Email Address`} value={companyData?.model.email} readOnly />
                            </Field>
                        </div>
                    </Tooltip>
                </div>
                <div className="flex basis-2/5 justify-center items-center ml-8">
                    <img src={ContactInformationGraphic} className="h[195px] w[348px]" />
                </div>
            </div>
        </>
    );
}
